import {JsonApiModelConfig, JsonApiModel, Attribute} from "angular2-jsonapi";
/**
 * Created by markush on 9/21/16.
 */

@JsonApiModelConfig({
  type: 'opening_hour'
})
export class OpeningHour extends JsonApiModel {

  @Attribute()
  weekDay: number;
  @Attribute()
  beginTime: string;
  @Attribute()
  endTime: string;
  @Attribute()
  breakTime: string;
  @Attribute()
  breakDurationMinutes: number;

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/shared/models/opening-hour.ts